@if (intelligenceBarVisible() && !isLoggedIn()) {
<aside class="intelligence-announcement" aria-label="Circled Intelligence (CI) announcement">
  <a routerLink="/" fragment="intelligence" (click)="closeMenu()" class="intelligence-announcement-link">
    <span>Meet <strong>Circled Intelligence (CI).</strong> Know the evidence behind your next home.</span>
    <span class="announcement-arrow" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14m-6-6 6 6-6 6"/></svg></span>
  </a>
  <button type="button" class="announcement-dismiss" aria-label="Dismiss Circled Intelligence (CI) announcement" (click)="dismissIntelligenceBar()"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m6 6 12 12M6 18 18 6"/></svg></button>
</aside>
}
<header class="site-header" [class.is-scrolled]="scrolled()">
<div class="header-inner">
<a routerLink="/" (click)="scrollToTop()" class="brand" aria-label="CircledPlus home">
<img class="brand-logo" src="/cir-home/images/circledplus-logo.svg" alt="CircledPlus" width="156" height="40"/>
</a>
<nav class="desktop-nav" aria-label="Main navigation">
<a routerLink="/search" (click)="closeMenu()">Properties</a>
<a routerLink="/" fragment="intelligence" (click)="closeMenu()">Circled Intelligence (CI)</a>
<a routerLink="/aboutus">About Us</a>
<a routerLink="/pricing">Pricing</a>
<a routerLink="/for-nri">NRI Hub</a>
<a href="https://blogs.circledplus.com/">Market Insights</a>
<a routerLink="/contactus">Contact Us</a>
</nav>
<div class="header-actions">
@if (isLoggedIn()) {
<details class="account-menu">
<summary class="control header-sign-in">My Account <svg class="account-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></summary>
<div class="account-dropdown">
<a routerLink="/search" (click)="closeMenu()">Explore Homes</a>
<a routerLink="/profile" (click)="closeMenu()">My Profile</a>
<button type="button" (click)="logout()">Sign Out</button>
</div>
</details>
} @else {
<a routerLink="/login" class="control header-sign-in">Sign In</a>
<a routerLink="/signup" class="ci-button header-access">Get Access <span aria-hidden="true">↗</span></a>
}
<button class="control mobile-menu-button" [attr.aria-label]="menuOpen() ? 'Close menu' : 'Open menu'" [attr.aria-expanded]="menuOpen()" (click)="toggleMenu()" type="button" aria-controls="mobile-navigation">@if (menuOpen()) {
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
<path d="m6 6 12 12M6 18 18 6"/>
</svg>
} @else {
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
<path d="M4 5h16M4 12h16M4 19h16"/>
</svg>
}</button>
</div>
</div>
@if (menuOpen()) {
<nav class="mobile-nav" id="mobile-navigation" aria-label="Mobile navigation">
<a routerLink="/search" (click)="closeMenu()">Properties</a>
<a routerLink="/" fragment="intelligence" (click)="closeMenu()">Circled Intelligence (CI)</a>
<a routerLink="/aboutus" (click)="closeMenu()">About Us</a>
<a routerLink="/pricing" (click)="closeMenu()">Pricing</a>
<a routerLink="/for-nri" (click)="closeMenu()">NRI Hub</a>
<a href="https://blogs.circledplus.com/">Market Insights</a>
<a routerLink="/contactus" (click)="closeMenu()">Contact Us</a>
@if (isLoggedIn()) {
<a routerLink="/profile" (click)="closeMenu()">My Account</a>
<button type="button" (click)="logout()">Sign Out</button>
} @else {
<a routerLink="/login" (click)="closeMenu()">Sign In</a>
<a routerLink="/signup" (click)="closeMenu()">Get Access</a>
}
</nav>
}
</header>
